import React from 'react'
import { FlatList } from 'react-native'

import styles from './styles'
import HGListItem from './HGListItem'

type Props = React.ComponentProps<typeof FlatList> & {
  renderItem?: any
  link: string
  style: any
}

const HGFlatList = (props: Props) => {
  const { style } = props

  return (
    <FlatList
      renderItem={({ item }) => <HGListItem item={item} />}
      {...props}
      style={[styles.listStyle, style]}
    />
  )
}

export default HGFlatList
